import { CommonModule } from "@angular/common";
import { Component, input } from "@angular/core";
import { ProductDto } from "@malirang/api-client";
import { ColumnDefinition } from "@malirang/front-share";

@Component({
    selector: "app-product-price",
    templateUrl: "./product-price.component.html",
    styleUrls: ["./product-price.component.css"],
    imports: [CommonModule],
})
export class ProductPriceComponent {
    row = input<ProductDto>();
    column = input<ColumnDefinition>();
}
